import type { ReactNode } from "react";

type DisplayConfig = {
  icon?: ReactNode;
  i18nKey: string;
};

type ConfigRecord = Record<string, DisplayConfig>;

export const createDisplayResolver = <TConfig extends ConfigRecord>(
  config: TConfig,
  legacyMap: Record<string, keyof TConfig>
) => {
  type Id = keyof TConfig;

  const normalizeKey = (rawKey: string): string => {
    return rawKey.toLowerCase().trim().replaceAll(" ", "").replaceAll("/", "").replaceAll("-", "");
  };

  const resolveId = (rawKey: string): Id | null => {
    if (!rawKey) return null;

    if (rawKey in config) {
      return rawKey as Id;
    }

    const normalized = normalizeKey(rawKey);
    return (legacyMap[normalized] as Id) ?? null;
  };

  const getDisplay = (rawKey: string): DisplayConfig | null => {
    const id = resolveId(rawKey);
    if (!id) return null;

    return config[id];
  };

  return {
    config,
    normalizeKey,
    resolveId,
    getDisplay,
  } as const;
};
